module.exports = __webpack_public_path__ + "static/media/userprofileimage.79b58b39.png";